<template>
    <div class="Table2">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="datetime" label="时间" align='center'></el-table-column>
            <el-table-column prop="conentvisitclient" label="浏览用户数" align='center'></el-table-column>
            <el-table-column prop="contentcount" label="评论数" align='center'></el-table-column>
            <el-table-column prop="contentusers" label="评论用户数" align='center'></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'Table2',
    props: ['instructionTableData'],
    data() {
        return {
            tableData: []
        }
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {
        instructionTableData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.tableData = this.instructionTableData
            })
        }
    },
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Table2 {}
</style>
